import axios from 'axios';
import type { TFunction } from 'i18next';

type NetworkErrorWithStatus = {
  response?: {
    status?: number;
  };
  statusCode?: number;
};

type ErrorWithNetworkError = Error & {
  networkError?: NetworkErrorWithStatus;
};

export const getHttpStatusFromError = (error: Error): number | undefined => {
  const apolloError = error as ErrorWithNetworkError;

  if (apolloError.networkError?.statusCode !== undefined) {
    return apolloError.networkError.statusCode;
  }

  if (apolloError.networkError?.response?.status !== undefined) {
    return apolloError.networkError.response.status;
  }

  if (axios.isAxiosError(error)) {
    return error.response?.status;
  }

  const response = (error as Error & { response?: { status?: number } }).response;

  return response?.status;
};

export const isGatewayTimeoutError = (error: Error): boolean => Number(getHttpStatusFromError(error)) === 504;

export const getSendMessageInlineErrorMessage = (error: Error, t: TFunction): string => {
  if (isGatewayTimeoutError(error)) {
    return t('Something went wrong while processing your request. Please try again later.');
  }

  return t('There was an error sending your request. Please try again.');
};
